export function getDropdownItems(numberItems) {
    return Array.from({
        length: numberItems,
    }, (_, i) => String(i + 1)).map((item) => ({
        value: item,
        label: item,
    }));
}
